<template>
    <div>
      <form>
        <div class="form-group">
          <label>Nome</label>
          <input
    
            type="text"
            class="form-control"
            v-model="estabelecimento.name"
            :disabled="isDisabled"
          />
        </div>
        <div class="form-group">
          <label>CNPJ</label>
          <input
            type="text"
            class="form-control"
            v-model="estabelecimento.cnpj"
            :disabled="isDisabled"
          />
        </div>
        <div class="form-group">
          <label>Email</label>
          <input
        
            type="text"
            class="form-control"
            v-model="estabelecimento.email"
            :disabled="isDisabled"
          />
        </div>
        <div v-if="false" class="form-group">
          <label>Responsavél</label>
          <input
        
            type="text"
            class="form-control"
            v-model="estabelecimento.responsible"
            :disabled="isDisabled"
          />
        </div>
   
        <div class="text-center">
          
          <button
            :disabled="isDisabled"
            v-if="!isDisabled"
            type="button"
            class="btn btn-light"
            @click="teste()"
          >
            Salvar
          </button>
          
        </div>
      </form>

    </div>
</template>
<script>
import { BButton } from 'bootstrap-vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
    components: {
    BButton,
  },
 
    data() {
        return {
            status: "",
            password: "",
            show: false,
            isDisabled: false,

            // estabelecimento: {
            //     name: null,
            //     cnpj: null,
            //     id: null,
            //     email: null,
            //     apiKey: null,
            //     responsible:null
            // },
        }
    },

    created() {
  
  },
  computed: {
    usuario() {
      return this.$store.state.login.usuario;
    },
    lista_estabelecimentos() {
      return this.$store.state.estabelecimentos.lista_estabelecimentos.data;
    },
    estabelecimento() {

    return this.$store.state.estabelecimentos.estabelecimento.allEstablishment;

      // return this.$store.state.estabelecimentos.estabelecimento.allEstablishment;
    },
  },

  methods: {
    teste(){
       this.estabelecimento = this.$store.state.estabelecimentos.estabelecimento.allEstablishment;
       console.log(this.estabelecimento)
    },
  async  SalvarEstabelecimento(){
    this.isDisabled = true
      const dados = {
         name: this.estabelecimento.name,
         cnpj: this.estabelecimento.cnpj,
         email: this.estabelecimento.email,
         company_id: this.usuario.companyId,
         responsible:this.estabelecimento.responsible
      }

       console.log(dados)

      await this.$store
        .dispatch("estabelecimentos/cadastrar", dados)
        .then((data) => {

            this.$toast({
            component: ToastificationContent,
            props: {
              title: "Salvo com sucesso",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.show = false
         
        })
        .catch((error) => {
          this.isDisabled = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erro:" + error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        
         
        });
      
     
    },
    showModalSenha(item) {
      this.isDisabled = true;
      this.estabelecimento = {
        id: item.id,
        name: item.name,
        cnpj: item.cnpj,
        email: item.email,
        apiKey: item.apiKey,
      };
      this.show = true;
    },
    showModalNovo() {
      this.estabelecimento = {
        id: null,
        name: null,
        cnpj: null,
        email: null,
        apiKey: null,
      };
    //   this.isDisabled = false;
      this.show = true;
    },
  },
};
</script>
    
<style lang="">
    
</style>